module.exports = __webpack_public_path__ + "static/img/BQ-SE.3fd36bff.svg";